import { z } from 'zod';
import { InitialStateSchema } from '../InitialState';

export const TriggersSchema = z.object({
  sensor: z.string(),
  value: z.string(),
  slideIds: z.array(z.string()),
  initialState: InitialStateSchema,
  slideGroupId: z.string().optional(),
  slideIndex: z.number().optional(),
});

export type Triggers = z.infer<typeof TriggersSchema>;

export const ScriptPayloadSchema = z.object({
  triggers: z.array(TriggersSchema),
});

export type ScriptPayload = z.infer<typeof ScriptPayloadSchema>;
